/**
 * Responsible for configuring and showing a pre-order message on the PDP.
 * 
 * Relevant images: https://drive.google.com/drive/folders/1glk8ndsWrjawv5_Y-AFLM4k4aTiLU8OE?usp=drive_link
 */

// New variant-specific pre-order JS
$(document).ready(function() {
    var variantId = $('.current-variant-meta').attr('data-variant-id');
    var preOrderDate = $('.current-variant-meta').attr('data-preorder-date');
    var variantSwatch = $('.swatches__form--label.js-preorder-date');
    var addToCartBtn = $('#pre-order-add-to-cart');
    var addToCartDefault = 'Add to Bag';
    var addToCartPreOrder = 'Pre-order';
    var preOrderField = $('#preorder_due_date');
    var preOrderPropName = 'properties[preorder_due_date]';

    let bigDaddyVariantSelector = $('.main-product-form .product__variants-select > select');
    let loadedVariantId = bigDaddyVariantSelector.val();

    // Sets the message is loaded product is pre-order
    $('.variant-preorder-message[data-variant-id="'+ loadedVariantId +'"]').addClass('show-preorder-message');

    $(document).on('change', bigDaddyVariantSelector, function(e) {
        
        let bigDaddyVariantId = bigDaddyVariantSelector.val();

        // Show pre-order message for current variant
        $('.variant-preorder-message[data-variant-id="'+ bigDaddyVariantId +'"]').addClass('show-preorder-message');

        // Update the selected variant's pre-order property value
        if (preOrderDate == "" || preOrderDate == undefined) {
            preOrderField.removeAttr('name');
            preOrderField.removeAttr('value');
        } else {
            preOrderField.attr('name', preOrderPropName);
            preOrderField.attr('value', preOrderDate);
            addToCartBtn.attr('value', addToCartPreOrder);
        }
    });

    // If a variantSwatch does not exist
    if (variantSwatch.length == 0) {
        // Show pre-order message for current variant
        $('.variant-preorder-message[data-variant-id="'+ variantId +'"]').addClass('show-preorder-message');
    }

    // Change pre-order message on switching variant 
    $(document).on('change', bigDaddyVariantSelector, function(e) {
        // Get variant Id from url query string & pre-order date for that variant
        let bigDaddyVariantId = bigDaddyVariantSelector.val();

        let variantId = bigDaddyVariantId;
        var preOrderDate = $('.variant-preorder-message[data-variant-id="'+ variantId +'"]').attr('data-preorder-date');

        // Update variant id data value
        if ($(e.target).hasClass('variant-selector-mini')) {
            let ctlCurrentVariantMeta = $(e.target).closest('.product__variant-selectors--mini'),
                ctlSelectedVariantId = ctlCurrentVariantMeta.siblings('.product__variant-select--mini').find('select').val(),
                ctlSelectedPreorderDate = ctlCurrentVariantMeta.siblings('.variant-preorder-message[data-variant-id="' + ctlSelectedVariantId + '"]').attr('data-preorder-date'),
                ctlSelectedPreorderDateField = ctlCurrentVariantMeta.siblings('.product__controls').find('.js-hidden-preorder-value');

            ctlCurrentVariantMeta.siblings('.current-variant-meta').attr('data-variant-id', ctlSelectedVariantId);

            // "fixing" a race condition with unminified script above
            setTimeout(function() {
                ctlCurrentVariantMeta.siblings('.product__controls').find('#pre-order-add-to-cart').html('Pre-order');
                ctlSelectedPreorderDateField.attr('name', 'properties[preorder_due_date]');
                ctlSelectedPreorderDateField.val(ctlSelectedPreorderDate);
                showCtlPreorderMessage();
            }, 100);
            
            ctlCurrentVariantMeta.siblings('.current-variant-meta').attr('data-preorder-date', ctlSelectedPreorderDate);
        } else {
            $('.current-variant-meta').attr('data-variant-id', variantId);
            $('.current-variant-meta').attr('data-preorder-date', preOrderDate);
        }        

        // Update the add to cart button & pre-order property input values
        if (preOrderDate == "" || preOrderDate == undefined) {
            preOrderField.removeAttr('name');
            preOrderField.removeAttr('value');

            // Set cart button value if the value isn't currently default
            if (addToCartBtn.attr('value') != addToCartDefault) {
                addToCartBtn.attr('value', addToCartDefault);
            }

        } else {
            preOrderField.attr('name', preOrderPropName);
            preOrderField.attr('value', preOrderDate);

            // Set cart button value if the value isn't currently pre-order
            if (addToCartBtn.attr('value') != addToCartPreOrder) {
                addToCartBtn.attr('value', addToCartPreOrder);
            }
        }

        setPreOrderTextOnButton();
        
        // Remove previous pre-order message & show pre-order message for new variant
        $('.variant-preorder-message').removeClass('show-preorder-message'); 
        $('.variant-preorder-message[data-variant-id="'+ variantId +'"]').addClass('show-preorder-message');

        // Grab the <select> variant options list and hide all product price wrappers that are related
        let optionsSelect = e.target;

        if (optionsSelect)
            $(optionsSelect).closest('form').find('.product-price-wrapper').css('display', 'none');

        // Show price wrapper for selected item
        $('.product-price-wrapper[data-variant-id="'+ variantId +'"]').css('display', 'block');
    });
});

function showCtlPreorderMessage() {
    setTimeout(function() {
        document.querySelectorAll('.ctl__product-form').forEach((item) => {
            let currentVariantId = item.querySelector('.current-variant-meta').getAttribute('data-variant-id');
    
            item.querySelectorAll('.variant-preorder-message').forEach((message) => {
                if (message.getAttribute('data-variant-id') == currentVariantId) {
                    message.style.display = 'flex';
                    if (item.querySelector('.product-mini__right').querySelector('.product__controls').querySelector('#preorder_due_date')) {
                        item.querySelector('.product-mini__right').querySelector('.product__controls').querySelector('#preorder_due_date').value = message.dataset.preorderDate;
                    }
                } else {
                    message.style.display = 'none';
                }
            });
        });
    }, 100);
}

$(document).ready(function() {
    showCtlPreorderMessage();
});